//IMPORTAÇÕES
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';

import { alertaAtencao } from '../../../utils/alternanciaIcones'

// COLETA CLICKSTREAM

/*  COMO USAR
    Importe a modal para dentro do componente que irá fazer uso dela.
    ex: import MensagemAtencao from '../componentesModais/mensagens/mensagemAtencao'

    Crie um hook apropriado para esconder e exibir a mensagem quando necessário.
    ex: const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)

    Após isso, posicione-a dentro do return do seu componente e passe os props para
    customizar o conteúdo da mensagem da seguinte forma.
    ex: { revelarMensagemAtencao &&
            <div className="componente-modal-overlay">
                <div className="componente-modal">
                    <MensagemAtencao
                        handleMensagemAtencao={handleMensagemAtencao}
                        mensagemTitulo={"TITULO DA MENSAGEM"}
                        mensagemParagrafo1={"CORPO DA MENSAGEM 1"}
                        mensagemParagrafo2={"CORPO DA MENSAGEM 2"}
                        mensagemParagrafo3={"CORPO DA MENSAGEM 3"}
                        mensagemBotao={"TEXTO DO BOTÃO"}
                        semBotaoCancelar // ISSO INSERIDO RETIRA O BOTÃO DE CANCELAR, DEIXANDO APENAS O OK  
                    />
                </div>
            </div>
        }
        
    Agora crie uma função para manejar o estado da mensagem e executar a função de
    fechamento padrão caso necessário.
    ex: function handleMensagemAtencao(confirmacao){
            if(revelarMensagemAtencao === false){
                setRevelarMensagemAtencao(true)
            }else{
                setRevelarMensagemAtencao(false)
                if(confirmacao === true){
                    //ALGUMA FUNÇÃO
                }
            }
        }*/

export default function MensagemAtencao(props) {
    //HOOK PRINCIPAIS
    const [mensagemTitulo, setMensagemTitulo] = useState('')
    const [mensagemParagrafo1, setMensagemParagrafo1] = useState('')
    const [mensagemParagrafo2, setMensagemParagrafo2] = useState('')
    const [mensagemParagrafo3, setMensagemParagrafo3] = useState('')
    const [mensagemBotao, setMensagemBotao] = useState('')
    const [semBotaoCancelar, setSemBotaoCancelar] = useState(false)

    const botaoCancelar = !semBotaoCancelar;

    //HOOKS MODAL
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar(false)
        }
    };

    function handleCancelar(confirmacao){
        if(confirmacao === true){
        props.handleMensagemAtencao(true)
        }else{
            props.handleMensagemAtencao(false)
            
            
        }
    }

    useEffect(() => {

        setMensagemTitulo(props.mensagemTitulo)
        setMensagemParagrafo1(props.mensagemParagrafo1)
        setMensagemParagrafo2(props.mensagemParagrafo2)
        setMensagemParagrafo3(props.mensagemParagrafo3)
        setMensagemBotao(props.mensagemBotao)
        setSemBotaoCancelar(props.semBotaoCancelar)
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [])

    return(
        <div className="mensagem-overlay">
            <div className="mensagem-container">
                <div ref={modal} className="mensagem-corpo fundo-cor-6">
                    <div className="mensagem-container-icone">
                        <img className="mensagem-icone" src={alertaAtencao()} alt="sucesso"/>
                    </div>
                    <div className="mensagem-container-titulo">
                        <div className="fonte-cor-1 label-titulo-mensagem">{mensagemTitulo}</div>
                    </div>
                    <div>
                        <div className="fonte-cor-1 label-corpo-mensagem">{mensagemParagrafo1}</div>
                    </div>
                    <div>
                        <div className="fonte-cor-1 label-corpo-mensagem">{mensagemParagrafo2}</div>
                    </div>
                    <div>
                        <div className="fonte-cor-1 label-corpo-mensagem">{mensagemParagrafo3}</div>
                    </div>
                    <div className="mensagem-container-botao">
                        {botaoCancelar &&
                        <Button className="mensagem-botao-cancelar" variant="success" size="sm" onClick={() => handleCancelar(false)}>
                            <div className="fonte-cor-2">{props.textoBtnCancelar || 'Cancelar'}</div>
                        </Button>
                        }
                        <Button className="mensagem-botao-confirmar" variant="success" size="sm" onClick={() => (botaoCancelar && props.confirmar) ? props.confirmar() : handleCancelar(true)}>
                            <div className="fonte-cor-4">{mensagemBotao}</div>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function RenderMensagemAtencao(props) {
    return (
    <div className="componente-modal-overlay">
        <div className="componente-modal">
            <MensagemAtencao {...props} />
        </div>
    </div>
    )
}